import React from "react";
import {Card, Col, Container, Row} from "react-bootstrap";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import {BiNetworkChart} from "react-icons/bi";
import {BsLayersHalf} from "react-icons/bs";
import {FiGlobe} from "react-icons/fi";
import {Link} from "react-router-dom";
import {useListContext} from "../../contexts/ListContext";
import {useTheCellMapContext} from "../../contexts/TheCellMapContext";
import {usePlotly} from "../../hooks/usePlotly";
import {DataType, FigureType} from "../../types/enums";
import SearchBox from "../SearchBox";
import ListCorrelations from "./ListCorrelations";
import ListDataType from "./ListDataType";
import ListEnrichments from "./ListEnrichments";
import ListFigure from "./ListFigure";
import ListFigureModal from "./ListFigureModal";
import ListGenePicker from "./ListGenePicker";
import ListQGIScores from "./ListQGIScores";
import ListRowModal from "./modal/ListRowModal";
import "../../css/list.css";

const ListUserInterface = () => {
  const {listState} = useListContext();
  const {setCurrentGene} = useTheCellMapContext();
  const plotlyLoaded = usePlotly();

  return (
    <Container fluid className="d-flex bg-white h-100 p-0">
      {/**
       g-1 controls spacing between columns;
       m-3 consistent margin all round
       */}
      <Row id="list-page-content" className="flex-grow-1 m-2 m-lg-3 g-2 g-lg-1">
        <Col id="list-left-panel" xs={12} lg={3} xl={2} className="d-flex flex-column gap-2 h-min-0 list-column-fill">
          <Row>
            <ButtonGroup vertical>
              <Link to="/"
                    className="btn btn-outline-dark text-start border d-flex align-items-center gap-2"><FiGlobe/> Global
                Network</Link>
              <Link to="/subnetwork"
                    className="btn btn-outline-dark text-start border d-flex align-items-center gap-2"><BiNetworkChart/> Subnetwork</Link>
              <Link to="/overlay"
                    className="btn btn-outline-dark text-start border d-flex align-items-center gap-2"><BsLayersHalf/> Overlay
                Data</Link>
            </ButtonGroup>
          </Row>
          <Row>
            <ListDataType/>
          </Row>
          <Row>
            <SearchBox isMulti={false} lastAdded={setCurrentGene} mobileInline/>
          </Row>
          <Row className="list-gene-picker-row h-min-0">
            <ListGenePicker/>
          </Row>
        </Col>
        <Col id="list-center-panel" xs={12} lg={6} xl={7} className="d-flex flex-column gap-2 h-min-0 list-column-fill">
          <Card className="card d-flex flex-column overflow-hidden flex-8 list-table-card">
            <Card.Body className="p-0 flex-1 h-min-0">
              <div className="h-100">
                {listState.dataType === DataType.Correlations ? <ListCorrelations/> : <ListQGIScores/>}
              </div>
            </Card.Body>
          </Card>
          <Card className="card d-flex flex-column overflow-hidden flex-4 list-enrichment-card mb-2 mb-lg-0">
            <Card.Body className="p-0 flex-1 h-min-0">
              <ListEnrichments/>
            </Card.Body>
          </Card>
          <ListRowModal/>
        </Col>
        <Col id="list-right-panel" xs={12} lg={3} className="d-none d-lg-flex flex-column gap-2 h-min-0 list-column-fill">
          {!plotlyLoaded ?
            <Card className="card flex-fill justify-content-center align-items-center">
              <div className="spinner-border" role="status"/>
            </Card> :
            listState.dataType === DataType.Correlations ? <>
              <ListFigure type={FigureType.CorrelationDecomp}/>
              <ListFigure type={FigureType.CorrelationSubnetworkG1}/>
              <ListFigure type={FigureType.CorrelationSubnetworkG2}/>
            </> : <>
              <ListFigure type={FigureType.ScoreAll}/>
              <ListFigure type={FigureType.ScoreQuery}/>
              <ListFigure type={FigureType.ScoreLibrary}/>
            </>
          }
        </Col>
      </Row>
      <ListFigureModal/>
    </Container>
  );
};

export default ListUserInterface;
